import { atom } from 'jotai';

export const $RelatedPostCarouselShow = atom(false);
